import React from "react";
import { Card, Table, message } from "antd";
import DashboardLayout from "../LayoutNavbar/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../LayoutNavbar/Navbars/DashboardNavbar";
import SoftButton from "StyleFeatures/SoftButton";
import "./Complaints.scss";
import useComplaints from "Hooks/EmployeeHooks/useComplaint";
import Select from "react-select";

function Complaints() {
  const {
    isLoading,
    show,
    employeeDetails,
    dataSource,
    columns,
    handleChange,
    handleSubmitComplaints,
    handleComplaints,
    formData,
    departments,
    setFormData,
    complaintTypes,
  } = useComplaints();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card title="Complaints" className="card-professional">
        {show && (
          <div className="row mb-3">
            <div className="col-md-12 mb-3">
              <SoftButton
                variant="outlined"
                style={{ float: "inline-end" }}
                color="info"
                size="small"
                onClick={handleComplaints}
              >
                <i className="fa fa-plus-circle" aria-hidden="true"></i>&nbsp;New Complaint
              </SoftButton>
            </div>
            <Table
              className="custom-table"
              bordered
              dataSource={dataSource}
              columns={columns}
              pagination={{ pageSize: 10 }}
            />
          </div>
        )}

        {!show && (
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="row g-3">
                  {/* Full Name */}
                  <div className="col-md-6 mb-3 d-flex">
                    <label className="form-label mb-0 me-2 fw-bold">Full Name:</label>
                    <span className="align-self-center fw-semibold">
                      {`${formData.firstName || ""} ${formData.lastName || ""}`}
                    </span>
                  </div>

                  {/* Phone */}
                  <div className="col-md-6 mb-3 d-flex">
                    <label className="form-label mb-0 me-2 fw-bold">Phone No:</label>
                    <span className="align-self-center fw-semibold">{formData.phoneNo}</span>
                  </div>

                   {/* Complaint Type */}
                  <div className="col-md-6">
                    <label className="form-label">Complaint Type *</label>
                    <select
                      name="complaintTypeId"
                      value={formData.complaintTypeId || ""}
                      onChange={(e) => {
                        const selectedId = Number(e.target.value);
                        const selectedType = complaintTypes?.find((ct) => ct.id === selectedId);

                        setFormData((prev) => ({
                          ...prev,
                          complaintTypeId: selectedId,
                          subComplaintTypeId: "", // reset subType when main changes
                          otherComplaintTypeText: "",
                          selectedComplaintType: selectedType || null,
                        }));
                      }}
                      className="form-select"
                    >
                      <option value="">-- Select Complaint Type --</option>
                      {complaintTypes?.map((type) => (
                        <option key={type.id} value={type.id}>
                          {type.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Sub-Types (only if harassment or similar has subTypes) */}
                  {formData.selectedComplaintType?.subTypes?.length > 0 && (
                    <div className="col-md-6">
                      <label className="form-label">Sub-Type *</label>
                      <select
                        name="subComplaintTypeId"
                        value={formData.subComplaintTypeId || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            subComplaintTypeId: Number(e.target.value),
                          }))
                        }
                        className="form-select"
                      >
                        <option value="">-- Select Sub-Type --</option>
                        {formData.selectedComplaintType.subTypes.map((sub) => (
                          <option key={sub.id} value={sub.id}>
                            {sub.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {/* Other Type Input (if isOtherType === true) */}
                  {formData.selectedComplaintType?.isOtherType && (
                    <div className="col-md-6">
                      <label className="form-label">Specify Other Type *</label>
                      <input
                        type="text"
                        name="otherComplaintTypeText"
                        value={formData.otherComplaintTypeText || ""}
                        maxLength={50}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            otherComplaintTypeText: e.target.value,
                          }))
                        }
                        className="form-control"
                        placeholder="Enter complaint type (max 50 chars)"
                      />
                    </div>
                  )}

                  {/* Department */}
                  <div className="col-md-6">
                    <label className="form-label">Department *</label>
                    <select
                      name="departmentId"
                      value={formData.departmentId ?? ""}
                      onChange={handleChange}
                      className="form-select"
                      key={formData.departmentId || "all"}
                      
                    >
                      <option value="">All Departments</option>
                      {Array.isArray(departments) &&
                        departments.map((dept) => (
                          <option key={dept.id} value={dept.id}>
                            {dept.name}
                          </option>
                        ))}
                    </select>
                  </div>

                  {/* Complaint Against */}
                  <div className="col-md-6">
                    <label className="form-label">Complaint Against *</label>
                    <Select
                      options={employeeDetails
                        .filter((emp) => emp.EmployeeId !== Number(formData.complainantEmployeeId)) // exclude self
                        .map((emp) => ({
                          value: emp.EmployeeId,
                          label: emp.employeeName,
                          departmentId: emp.departmentId,
                        }))}
                   value={
  employeeDetails.length && formData.complaintAgainstEmployeeId
    ? {
        value: formData.complaintAgainstEmployeeId,
        label:
          employeeDetails.find(
            (e) => e.EmployeeId === formData.complaintAgainstEmployeeId
          )?.employeeName || "",
      }
    : null
}                      onChange={(selected) => {
                        if (selected) {
                          setFormData((prev) => ({
                            ...prev,
                            complaintAgainstEmployeeId: selected.value, //  store numeric id
                            complaintAgainstName: selected.label,
                            departmentId: selected.departmentId || prev.departmentId,
                          }));
                        } else {
                          setFormData((prev) => ({
                            ...prev,
                            complaintAgainstEmployeeId: "",
                            complaintAgainstName: "",
                          }));
                        }
                      }}
                      isClearable
                      isSearchable
                      placeholder="Select employee..."
                      styles={{ container: (base) => ({ ...base, width: "100%" }) }}
                    />
                  </div>

                  {/* Incident Date & Time */}
                  <div className="col-md-6">
                    <label className="form-label">Incident Date & Time *</label>
                    <input
                      type="datetime-local"
                      name="timeOfIncident"
                      value={formData.timeOfIncident ? formData.timeOfIncident.slice(0, 16) : ""}
                      max={new Date().toISOString().slice(0, 16)} //  prevent future
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>

                  {/* Details */}
                  <div className="col-md-12">
                    <label className="form-label">Details of Incident *</label>
                    <textarea
                      rows="3"
                      name="detailOfIncident"
                      value={formData.detailOfIncident || ""}
                      onChange={handleChange}
                      className="form-control"
                    />
                  </div>

                  {/* Submit */}
                  <div className="col-md-12 text-end">
                    <SoftButton
                      type="button"
                      variant="outlined"
                      color="info"
                      size="small"
                      onClick={handleSubmitComplaints}
                    >
                      {isLoading ? "Submitting..." : "Submit"}
                      {isLoading && <span className="spinner-border spinner-border-sm"></span>}
                    </SoftButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Card>
    </DashboardLayout>
  );
}

export default Complaints;
